import { createAsyncThunk } from '@reduxjs/toolkit';
import store, { waitForCustomerLogin } from '../../store/store';
import { getOrderHistoryMagentoApiCall, getOrderHistoryShopMagentoApiCall } from './order-history.apis';
import { getOrderHistoryStatus } from './order-history.selectors';
import { OrderHistory } from './order-history.interface';
import { ActionStatus } from '../../common/constants/action-status';
import { getCustomerToken } from '../customer/customer';
import { StoreState } from '../../store/store.interface';
import { handleApiError, ApiError } from '../../common/utils/api-utils';

/*----- DECLARE THUNKS ------*/
export interface OrderHistoryParams {
  forceUpdate?: boolean;
  currentPage?: string;
  pageSize?: string;
  sortOrder?: string;
  sortBy?: string;
}

export const fetchOrderHistory = createAsyncThunk('orderHistory/fetchOrderHistory', async (params: OrderHistoryParams, thunkAPI) => {
    try {
      const userProfileResponse = store.getState().userProfileState.userProfileResponse;
      /*
        Checking it due the redirect to login page on the order-history.ts and to avoid
        a call to the API that will be closed by the browser during the redirect.
      */
      if (userProfileResponse?.status !== ActionStatus.succeeded || !userProfileResponse.data) {
        return;
      }

      await waitForCustomerLogin();
      const token = getCustomerToken(thunkAPI.getState() as StoreState);

      // [SHOP-API-REMOVAL][WECOMM-20796] The `if (environment().useMagento)`
      // gate has been removed. Production has been Magento-only for order
      // history; the fallback that returned an empty array when the flag was
      // false is gone.
      const magentoOrderHistory: OrderHistory[] = await getOrderHistoryMagentoApiCall(params, token);

      return magentoOrderHistory.concat(await getOrderHistoryShopMagentoApiCall(token)).sort((a, b) => new Date(b.orderedDate).getTime() - new Date(a.orderedDate).getTime());
    } catch (error) {
      if (error instanceof ApiError) {
        handleApiError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: ({forceUpdate}, { getState }) => {
      return forceUpdate || ![ActionStatus.succeeded, ActionStatus.loading ].includes(getOrderHistoryStatus(getState() as StoreState));
    },
  }
);
